module.exports = __webpack_public_path__ + "img/blockS2-img.fad7ff45.svg";